<template>
    <process-directory
        :type="5"
        title="Recuperações extrajudiciais"
        route-base="/recuperacao-extrajudicial"
    />
</template>
<script>
import ProcessDirectory from '@/components/ProcessDirectory.vue';
export default { name: 'ExtrajudicialRecoveryPage', components: { ProcessDirectory } };
</script>
